module.exports = __webpack_public_path__ + "img/FilterThroughDataPoints.f122992e.svg";